'use strict';
var constants = require('./constants');
var listen = require('event-listener');
var redirect = require('./redirect');
var _log = require('./util/log');

function _getBtnContainers(el, result) {
    // either an array or nodelist
    if (el.constructor.toString().indexOf('Array') > -1 || el.length > 0 && typeof el.item !== 'undefined') {
        for (var i = 0; i < el.length; i++) {
            _getBtnContainers(el[i], result);
        }
    } else {
        var domEl = typeof el === 'string' ? document.getElementById(el) : el;

        if (domEl) {
            result.push(domEl);
        } else {
            _log(constants.ERROR_MESSAGES.SETUP_MISSING_ELEMENT + el);
        }
    }
}

function _getBtnObject(element, clickFn, condFn) {
    return {
        element: element,
        clickFn: clickFn,
        condFn: condFn
    };
}

function _addButtonElement(config, btnList, jsBtnConfigs, container, btnOptions, clickFn, condFn) { // eslint-disable-line max-params

    var dataAttrs = {
        lc: (config.merchantConfig && config.merchantConfig.locale) || 'en_US',
        color: btnOptions.color || 'gold',
        shape: btnOptions.shape || 'pill',
        size: btnOptions.size || 'small'
    };

    var buttonDom = window.paypal.button.create(config.merchantID, dataAttrs, { // eslint-disable-line no-undef
        label: btnOptions.label,
        type: 'button'
    });

    var buttonEle = buttonDom.el,
        btnTagEle = buttonEle.getElementsByTagName('BUTTON')[0];

    if (config.enableOneTouch) {

        if (!document.getElementById(constants.ONETOUCH_IFRAME_ID)) {
            var oneTouchIframe = document.createElement('iframe');
            oneTouchIframe.setAttribute('id', constants.ONETOUCH_IFRAME_ID);
            oneTouchIframe.setAttribute('src', constants.ONETOUCH_IFRAME_URL);
            oneTouchIframe.style.display = 'none';
            document.body.appendChild(oneTouchIframe);
        }
    }

    // should bind onclick event in here
    if (container.nodeName === 'A') {
        btnList.push(_getBtnObject(container, clickFn, condFn));

        // for IE8-, button inside of link doesn't work
        if (config.oldIe) {
            listen(btnTagEle, 'click', function () {
                redirect(container.getAttribute('href'));
            });
        }
        // a form
    } else {
        btnList.push(_getBtnObject(btnTagEle, clickFn, condFn));
    }
    container.appendChild(buttonEle);

    // Add js button related options for tracking
    dataAttrs.label = btnOptions.label;
    jsBtnConfigs.push(dataAttrs);

}

function buttonGenerator(config, jsBtnConfigs, btnList) {

    var merchantConfig = config.merchantConfig,
        jsBtnIds = merchantConfig && merchantConfig.container,
        customBtnIds = merchantConfig && merchantConfig.button,
        jsBtnTypes = merchantConfig && merchantConfig.type || [],
        color = merchantConfig && merchantConfig.color,
        size = merchantConfig && merchantConfig.size,
        shape = merchantConfig && merchantConfig.shape,
        condFn = merchantConfig && merchantConfig.condition,
        clickFn = merchantConfig && merchantConfig.click,
        btnsConfigList = merchantConfig && merchantConfig.buttons,
        btnContainers = [];

    if (btnsConfigList && btnsConfigList.length) {
        for (var i = 0; i < btnsConfigList.length; i++) {
            var btnConfig = btnsConfigList[i];
            var elId = btnConfig.container || btnConfig.button;
            var elDom = typeof elId === 'string' ? document.getElementById(elId) : elId;

            if (btnConfig.container) {
                _addButtonElement(config, btnList, jsBtnConfigs, elDom, {
                    label: btnConfig.type || 'checkout',
                    color: btnConfig.color,
                    shape: btnConfig.shape,
                    size: btnConfig.size
                }, btnConfig.click, btnConfig.condition);
            } else if (btnConfig.button) {
                btnList.push(_getBtnObject(elDom, btnConfig.click, btnConfig.condition));
            }
        }
    } else {
        // get all container list
        _getBtnContainers(jsBtnIds || customBtnIds, btnContainers);

        for (var j = 0; j < btnContainers.length; j++) {
            if (customBtnIds) {
                btnList.push(_getBtnObject(btnContainers[j], clickFn, condFn));
            } else {
                var buttonParams = {
                    label: jsBtnTypes[j] || 'checkout',
                    color: color,
                    shape: shape,
                    size: size
                };
                _addButtonElement(config, btnList, jsBtnConfigs, btnContainers[j], buttonParams, clickFn, condFn);
            }
        }
    }

    return btnList;
}

module.exports = buttonGenerator;



/*****************
 ** WEBPACK FOOTER
 ** ./src/js/gen-button.js
 ** module id = 13
 ** module chunks = 0
 **/